import { connect } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";

// Core
import { getGameCompleted, getFormCompleted, getUid } from "../../core/session";

// Components
import Form from "./form";
import Game from "./game";
import Completed from "./completed";

const App = ({ gameCompleted, formCompleted, uid }) => {
    if (!formCompleted) {
        return <Form />;
    }

    if (gameCompleted) {
        return <Completed />;
    }

    return <Game />;
};

const mapStateToProps = createSelector(
    getGameCompleted,
    getFormCompleted,
    getUid,
    (gameCompleted, formCompleted, uid) => ({
        gameCompleted,
        formCompleted,
        uid,
    })
);

export default connect(mapStateToProps, null)(App);
